import { React, useState } from "react";
import { setlocalChalanDetail } from "../../storeSlices/localChalanSlice";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./ShowChalan.css";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import PrintLocalChallanRasid from "./PrintLocalChallanRasid";
import LocalChalanRasid from "./LocalChalanRasid";
import "./Chalan.css";
import { CardContent, CardActions } from "@mui/material";

const classes = {
  cardContainer: {
    boxSizing: "border-box",
    boxShadow:
      "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
    borderRadius: "1rem",
    padding: "2vmax",
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
  },
  printContainer: {
    position: "absolute",
    height: "80%",
    overflow: "scroll",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
  },
  formContainer: {
    position: "absolute",
    height: "100%",
    overflow: "scroll",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  },
};

function ShowLocalChalans({ localchallan }) {
  const [details, setdetails] = useState({
    truck_no: localchallan.truck_no ? localchallan.truck_no : "",
    date: localchallan.date ? localchallan.date : "",
    owner: localchallan.owner ? localchallan.owner : "",
    phone: localchallan.phone ? localchallan.phone : "",
    driver: localchallan.driver ? localchallan.driver : "",
    driver_mobile_number: localchallan.driver_mobile_number
      ? localchallan.driver_mobile_number
      : "",
    driver_pan_no: localchallan.driver_pan_no ? localchallan.driver_pan_no : "", //
    goodsLoadedFrom: localchallan.goodsLoadedFrom
      ? localchallan.goodsLoadedFrom
      : "",
    goodsLoadedTo: localchallan.goodsLoadedTo ? localchallan.goodsLoadedTo : "",
    Bookedby: localchallan.Bookedby ? localchallan.Bookedby : "", //
    consignment: localchallan.consignment ? localchallan.consignment : "", //
    cargo_freight: localchallan.cargo_freight ? localchallan.cargo_freight : "",
    weight: localchallan.weight ? localchallan.weight : "",
    rate_per_unit: localchallan.rate_per_unit ? localchallan.rate_per_unit : "",
    total_freight: localchallan.total_freight ? localchallan.total_freight : "",
    advance_amount: localchallan.advance_amount
      ? localchallan.advance_amount
      : "",
    diesel: localchallan.diesel ? localchallan.diesel : "",
    dieselQty: localchallan.dieselQty ? localchallan.dieselQty : "",
    dieselPerLiter: localchallan.dieselPerLiter
      ? localchallan.dieselPerLiter
      : "",
    petrol_pump_name: localchallan.petrol_pump_name
      ? localchallan.petrol_pump_name
      : "",
    challan_no: localchallan.challan_no ? localchallan.challan_no : "",

    gr_no: localchallan.gr_no ? localchallan.gr_no : "",
    other_exp: localchallan.other_exp ? localchallan.other_exp : "",
    commission: localchallan.commission ? localchallan.commission : "",
    balance_freight: localchallan.balance_freight
      ? localchallan.balance_freight
      : "",
  });

  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  // const handleOpen = () => setOpen(true);
  const handleClose = () => {
    console.log("first");
    setOpen(false);
  };
  const handleClose2 = () => {
    console.log("second");
    setOpen2(false);
  };

  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const editlocalChallan = (localchallan) => {
    console.log("editpage : ", localchallan);
    setOpen(true);
  };
  const printlocalChallan = (localchallan) => {
    console.log("printpage : ", localchallan);
    dispatch(setlocalChalanDetail(localchallan));
    setOpen2(true);
  };
  const handleChange = (e) => {
    setdetails({ ...details, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // console.log(details);
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/localchallan/${localchallan.id}`,
      //`http://localhost:5000/localchallan/${localchallanId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
        },
        body: JSON.stringify(details),
      }
    );

    const json = await response.json();
    console.log("local challan", json);

    // first validate chalan details
    // dispatch(validateLocalChalanDetail(details));

    // set chalan details
    dispatch(setlocalChalanDetail(details));

    document.getElementById("bill-form").classList.toggle("c-form");
    document.getElementById("bill-template").classList.toggle("bill");
  };
  return (
    <Box className="ch-bx" sx={classes.cardContainer}>
      <CardContent>
        <Typography variant="h6">
          <b>Challan no ⇝ {details.challan_no}</b>
        </Typography>
        <Typography variant="h6">
          <b>BookedBy ⇝ {details.Bookedby}</b>
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="large" onClick={() => editlocalChallan(localchallan)}>
          Edit
        </Button>
        <Button size="large" onClick={() => printlocalChallan(localchallan)}>
          Print
        </Button>
      </CardActions>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={classes.formContainer}>
          <form className="chalan-form" onSubmit={handleSubmit} id="bill-form">
            <label>
              Vehicle No:
              <input
                type="text"
                name="truck_no"
                value={details.truck_no}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Challan No:
              <input
                type="text"
                name="challan_no"
                value={details.challan_no}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Date:
              <input
                type="date"
                name="date"
                value={details.date}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Owner Name And Address:
              <input
                type="text"
                name="owner"
                value={details.owner}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Owner Mobile Number:
              <input
                type="number"
                name="phone"
                value={details.phone}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Driver Name:
              <input
                type="text"
                name="driver"
                value={details.driver}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Driver Pan Number:
              <input
                type="text"
                name="driver_pan_no"
                value={details.driver_pan_no}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Driver Mobile Number:
              <input
                type="number"
                name="driver_mobile_number"
                value={details.driver_mobile_number}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Goods Loaded From:
              <input
                type="text"
                name="goodsLoadedFrom"
                value={details.goodsLoadedFrom}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Goods Loaded To:
              <input
                type="text"
                name="goodsLoadedTo"
                value={details.goodsLoadedTo}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Booked By:
              <input
                type="text"
                name="Bookedby"
                value={details.Bookedby}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Bill of Entry Number:
              <input
                type="text"
                name="consignment"
                value={details.consignment}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              GR Number:
              <input
                type="text"
                name="gr_no"
                value={details.gr_no}
                onChange={handleChange}
              />
            </label>
            <br />
            {/* <label>
              Cargo freight:
              <input
                type="number"
                name="cargo_freight"
                value={details.cargo_freight}
                onChange={handleChange}
              />
            </label>
            <br /> */}
            <label>
              Weight:
              <input
                type="number"
                name="weight"
                value={details.weight}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Rate Per Unit:
              <input
                type="number"
                name="rate_per_unit"
                value={details.rate_per_unit}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Total Freight:
              <input
                type="number"
                name="total_freight"
                value={details.total_freight}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Petrol Pump Name:
              <input
                type="text"
                name="petrol_pump_name"
                value={details.petrol_pump_name}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Diesel Qty:
              <input
                type="text"
                name="dieselQty"
                value={details.dieselQty}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Diesel Per L:
              <input
                type="text"
                name="dieselPerLiter"
                value={details.dieselPerLiter}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Advanced Freight:
              <input
                type="number"
                name="advance_amount"
                value={details.advance_amount}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              diesel:
              <input
                type="text"
                name="diesel"
                value={details.diesel}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Other Exp:
              <input
                type="number"
                name="other_exp"
                value={details.other_exp}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              commission:
              <input
                type="number"
                name="commission"
                value={details.commission}
                onChange={handleChange}
              />
            </label>
            <br />
            <label>
              Balance Freight:
              <input
                type="number"
                name="balance_freight"
                value={details.balance_freight}
                onChange={handleChange}
              />
            </label>
            <br />
            <input
              className="generate"
              type="submit"
              value="Generate Local Chalan"
            />
          </form>
          <LocalChalanRasid localChalan={details} />
        </Box>
      </Modal>
      <Modal
        open={open2}
        onClose={handleClose2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={classes.printContainer}>
          <PrintLocalChallanRasid localChalan={details} />
        </Box>
      </Modal>
    </Box>
  );
}

export default ShowLocalChalans;
